/* global Vue, LOYALTY_INTERESTS */

import CldImg from '../../apps/components/CldImg'

export default {
  name: 'AwardCard',
  components: { CldImg },
  template: `
<div class="card card--award">
  <a :href="award.link" :title="award.title" class="card__image">
    <CldImg :alt="award.title" :src="award.image" />
    <div class="card__points">
      <strong>{{ award.points }}</strong>
      {{ $t('awards.points') }}
    </div>
  </a>
  <div class="card__tags">
    <span
      v-if="'available' in award"
      :class="isAvailable ? 'available' : 'available available--not'">
      {{ isAvailable ? $t('awards.available') : $t('awards.unavailable') }}
    </span>
    <span v-else>
      <span v-for="destination in award.destinations">{{ destination }}</span>
    </span>
    <span v-for="interest in award.interests">{{ interestTitle(interest) }}</span>
  </div>
  <div>
    <a class="h3" :href="award.link">{{ award.title }}</a>
  </div>
  <p>{{ award.description }}</p>
  <a :href="award.link" class="button button--outline">{{ $t('awards.discoverMore') }}</a>
</div>
  `,
  props: { award: Object },
  setup (props, { emit }) {
    const isAvailable = Vue.computed(() => props.award.available === 1)

    const interestTitle = (key) => {
      return (LOYALTY_INTERESTS.find(i => i.key === key))?.title
    }

    return {
      interestTitle,
      isAvailable,
    }
  },
}
